import React, { createContext, useContext, useEffect, useRef, useState } from 'react'

const Context = createContext();
function App({ children }) {
    let userdata = localStorage.getItem('user');
    if (userdata) {
        userdata = JSON.parse(userdata);
    } else {
        userdata = null;
    }
    const [user, setUser] = useState(userdata);
    let [webSocket, setWebSocket] = useState();

    useEffect(() => {
        if (!webSocket) {
            setWebSocket(new WebSocket('wss://boukanagahi.ir:3000/comm'));
        }
    }, [webSocket])




    const login = (data) => {
        localStorage.setItem('user', JSON.stringify(data));
        setUser(data);
    }

    const logout = () => {
        localStorage.clear();
        setUser(null);
    }


    return (
        <Context.Provider value={{ user, login, webSocket, logout, setUser }}>{children}</Context.Provider>
    )
}
export const useAppContext = () => useContext(Context);
export default App